const state = {
  loading: false,
};

const getters = {};

const actions = {};

const mutations = {
  SHOW_LOADING(state) {
    state.loading = true;
  },
  DISABLE_lOADING(state) {
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
